import { identity, unwrap } from "../api";

/**
 * Ported from apps/admin/app/(app)/account/actions.ts, through the generated identity client
 * (FR-006). Neither call is permission-gated — both act on the caller's own account, and the
 * matrix has nothing to say about whether you may read or rename yourself (backend's own
 * `MeQueries` remark). No role is compared here.
 */
export async function changeDisplayName(displayName: string): Promise<void> {
  await unwrap((await identity()).PUT("/api/identity/me/name", { body: { displayName: displayName.trim() } }));
}

export async function changePassword(currentPassword: string, newPassword: string): Promise<void> {
  await unwrap((await identity()).POST("/api/identity/me/password", { body: { currentPassword, newPassword } }));
}
